var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-filter-log" },
    [
      _vm.isFilterDetail
        ? _c(
            "b-form-group",
            [
              _c("label", [_vm._v("Block ID")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: { placeholder: "Block ID" },
                model: {
                  value: _vm.dataForm.blockId,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "blockId", $$v)
                  },
                  expression: "dataForm.blockId"
                }
              })
            ],
            1
          )
        : _c("b-form-group", [
            _c("label", [_vm._v("Time Range")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "time-range" },
              [
                _c("j-date-time", {
                  attrs: {
                    data: _vm.dataForm.startDate,
                    type: "datetime",
                    placeholder: "Start Date Time",
                    format: "MMM dd, yyyy, HH:mm"
                  },
                  on: {
                    getTimestamp: function($event) {
                      _vm.setValueDateAndAtime($event, "startDate")
                    }
                  }
                }),
                _vm._v(" "),
                _c("j-date-time", {
                  attrs: {
                    data: _vm.dataForm.endDate,
                    type: "datetime",
                    placeholder: "End Date Time",
                    format: "MMM dd, yyyy, HH:mm"
                  },
                  on: {
                    getTimestamp: function($event) {
                      _vm.setValueDateAndAtime($event, "endDate")
                    }
                  }
                })
              ],
              1
            )
          ]),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c("label", [_vm._v("Status")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              options: _vm.statusOptions,
              placeholder: "Select Status",
              label: "label"
            },
            model: {
              value: _vm.dataForm.status,
              callback: function($$v) {
                _vm.$set(_vm.dataForm, "status", $$v)
              },
              expression: "dataForm.status"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("b-form-group", [
        _c("label", [_vm._v("Total Runtime (in millisecond)")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "runtime" },
          [
            _c("j-single-select", {
              attrs: {
                options: _vm.operatorOptions,
                placeholder: "Operator",
                label: "label"
              },
              model: {
                value: _vm.dataForm.runtime.operator,
                callback: function($$v) {
                  _vm.$set(_vm.dataForm.runtime, "operator", $$v)
                },
                expression: "dataForm.runtime.operator"
              }
            }),
            _vm._v(" "),
            _c("j-input", {
              attrs: {
                type: "number",
                placeholder: "Total Runtime in millisecond"
              },
              model: {
                value: _vm.dataForm.runtime.value,
                callback: function($$v) {
                  _vm.$set(_vm.dataForm.runtime, "value", $$v)
                },
                expression: "dataForm.runtime.value"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-form" }, [
        _c(
          "button",
          {
            staticClass: "button-grey",
            on: {
              click: function($event) {
                _vm.resetDataForm()
              }
            }
          },
          [_vm._v("\n      Reset\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button-blue",
            on: {
              click: function($event) {
                _vm.applyFilter()
              }
            }
          },
          [_vm._v("\n      Apply\n    ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72de7902", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72de7902","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/popover/jPopoverFilterRunHistory.vue
// module id = null
// module chunks = 